import React from 'react';

import { useIntl } from 'react-intl';

import { useCreateValidationType } from 'src/features/validationTypes/api/useCreateValidationType';
import { LIST_VALIDATION_TYPES_RESOURCE } from 'src/features/validationTypes/api/useListValidationTypes';
import ValidationTypeFormModal from 'src/features/validationTypes/components/forms/ValidationTypeFormModal';
import { validationTypesMessages } from 'src/features/validationTypes/utils/messages';
import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { ICON_MAP } from 'src/utils/constants';
import { useParking } from 'src/providers/ParkingProvider';

interface CreateValidationTypeFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateValidationTypeFormModal<TData>({ className }: CreateValidationTypeFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const { parkingId } = useParking();

    const { mutate, isPending } = useCreateValidationType({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_VALIDATION_TYPES_RESOURCE] });
            toast({
                title: formatMessage(validationTypesMessages.createValidationTypeSuccess),
                description: formatMessage(validationTypesMessages.createValidationTypeSuccessDescription),
            });
        },
    });

    return (
        <ValidationTypeFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate({ parkingId, ...values }, { onSuccess, onError })}
            title={formatMessage(validationTypesMessages.newValidationType)}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(validationTypesMessages.addValidationTypeModalSubtitle)}
        />
    );
}

export default CreateValidationTypeFormModal;
